/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { colors, layers } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const Loader = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  padding-top: ${token('space.800', '64px')};
  display: flex;
  align-items: flex-start;
  justify-content: center;
  pointer-events: none;
  background: ${token('color.background.neutral.subtle', colors.N0)};
  opacity: 0.5;
  z-index: ${layers.card() + 10};
`;
